/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import React, { FC } from "react"

import {
  ReturnRequestItem,
  ReviewDecision,
} from "ecommerce/constants/returnRefund"

import { ReturnReviewItemCard } from "./ReturnReviewItemCard"
import styles from "./ReturnReviewPanel.modules.css"

interface ReturnReviewPanelProps {
  items: ReturnRequestItem[]
  /**
   * Controlled by the drawer, which owns the decisions because `Confirm` lives in its
   * footer rather than in this panel.
   */
  decisions: Record<string, ReviewDecision>
  onChange(
    itemID: string,
    update: (previous?: ReviewDecision) => ReviewDecision | undefined,
  ): void
  /** Stages one added photo as a server-side draft — see the card's prop. */
  onUploadPhoto(
    item: ReturnRequestItem,
    file: File,
    mediaSource?: string,
  ): Promise<string>
  /** Deletes one server-staged draft photo — see the card's prop. */
  onRemovePhoto(item: ReturnRequestItem, assetID: string): Promise<boolean>
  /** Buyer-chat hand-off from the narrow action sheet; the host owns the destination. */
  onRequestChat(item: ReturnRequestItem): Promise<boolean>
}

export const ReturnReviewPanel: FC<ReturnReviewPanelProps> = ({
  items,
  decisions,
  onChange,
  onUploadPhoto,
  onRemovePhoto,
  onRequestChat,
}) => (
  <div className={styles.panel}>
    {items.map(item => (
      <ReturnReviewItemCard
        key={item.id}
        item={item}
        decision={decisions[item.id]}
        onChange={onChange}
        onUploadPhoto={onUploadPhoto}
        onRemovePhoto={onRemovePhoto}
        onRequestChat={onRequestChat}
      />
    ))}
  </div>
)
